import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import Preloader from '../../ui/components/ui/preloader';
import { useEffect } from 'react';
import { UserRole, UserType } from '../../lib/interfaces/user';

const HomeRedirect = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    if (user.userType === UserType.Customer) {
      navigate('/order', { replace: true });
      return;
    }
    if (user.userType === UserType.Internal) {
      if (user.userRole === UserRole.Admin || user.userRole === UserRole.SuperAdmin || user.isTeamLeader) {
        navigate('/dashboard', { replace: true });
        return;
      }
      if (user.userRole === UserRole.User) {
        navigate('/bonus', { replace: true });
        return;
      }
      return;
    }

    return;
  }, [user, navigate]);

  return <Preloader />;
};

export default HomeRedirect;
